var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container blog-post__description py-5",class:'body-color-' + _vm.block.links_color},[(_vm.block.body)?_c('div',{staticClass:"mb-4",domProps:{"innerHTML":_vm._s(_vm.$md.render(_vm.block.body))}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }